import { Edit, ShoppingCart } from '@mui/icons-material';
import { IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useMemo } from 'react';

import { formatCommunityProductPrice } from '@jebel/utils';

import { CommunityProductFragment, CommunitySubscriptionFragment } from 'shared/graphql';
import { useMediaDetailer, useMediaPreview } from 'shared/hooks';

import { ProductLogo } from './CommunityProductListItem.styles';

interface Props {
  product: CommunityProductFragment | CommunitySubscriptionFragment;

  /**
   * Callback to edit the product.
   */
  onEdit: () => void;
}

export function CommunityProductListItem({ product, onEdit }: Props) {
  const { data: image } = useMediaDetailer(product.image);
  const { src: logoSrc, srcSet: logoSrcSet } = useMediaPreview(product.image);

  const secondaryText = useMemo(() => {
    return formatCommunityProductPrice(product);
  }, [product]);

  return (
    <ListItem
      secondaryAction={
        <IconButton onClick={onEdit}>
          <Edit />
        </IconButton>
      }
    >
      <ListItemIcon>
        <ProductLogo
          src={logoSrc}
          srcSet={logoSrcSet}
          color={product.membership?.color}
          alt={image?.filename ?? product.name}
        >
          <ShoppingCart fontSize="inherit" />
        </ProductLogo>
      </ListItemIcon>

      <ListItemText primary={product.name} secondary={secondaryText} />
    </ListItem>
  );
}
